import { render, staticRenderFns } from "./Ratio.vue?vue&type=template&id=bd0a5b68&scoped=true&"
import script from "./Ratio.vue?vue&type=script&lang=js&"
export * from "./Ratio.vue?vue&type=script&lang=js&"
import style0 from "./Ratio.vue?vue&type=style&index=0&id=bd0a5b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0a5b68",
  null
  
)

export default component.exports